import { SecurityTypeResponseAuditable } from '../../../../web-api-client';
import { SecurityType } from '../../models';

export const mapSecurityTypeFromResponse = (
  response: SecurityTypeResponseAuditable
): SecurityType => ({
  securityTypeId: response.securityTypeId!,
  name: response.name ?? '',
  isActive: response.isActive ?? false,
  created: response.created!,
  isParent: response.isParent!,
  parentName: response.isParent
    ? ''
    : (response.parentSecurityType?.name ?? ''),
  parentSecurityTypeId: response.isParent
    ? undefined
    : (response.parentSecurityType?.securityTypeId ?? undefined),
});
